import { render, staticRenderFns } from "./channelList.vue?vue&type=template&id=e356d904&scoped=true"
import script from "./channelList.vue?vue&type=script&lang=js"
export * from "./channelList.vue?vue&type=script&lang=js"
import style0 from "./channelList.vue?vue&type=style&index=0&id=e356d904&prod&lang=less&scoped=true"
import style1 from "./channelList.vue?vue&type=style&index=1&id=e356d904&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e356d904",
  null
  
)

export default component.exports